import styled from "styled-components";

export const Styles = styled.div`
  .max-w-1040 {
    max-width: 1040px;
  }
  .desktop & {
    .container_button_action_and_list {
      .container_button_action {
        width: 362px;
      }
    }
  }

  .container_button_action {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px 16px;

    .orther-btn-container {
      grid-column: 1 / -1;
    }

    .other-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
    }
  }

  .select-button {
    display: flex;
    flex: end;
    gap: 22px;
    justify-content: end;

    .ant-select {
      flex: 1 1 auto;
      min-width: 0;
    }

    .attendance-management-btn {
      background: #4759ff;
      border-color: #4759ff;
      font-weight: 500;
      display: flex;
      gap: 4px;
      border-radius: 8px;
      height: 32px;
      font-size: 16px;
      line-height: 19px;
      * {
        color: #ffffff !important;
      }
    }

    .ant-select-selector {
      border: 1px solid #5d5d5d;
      border-radius: 2px;
      font-size: 16px;
    }

    .ant-select-selection-item,
    .ant-select-selection-search-input {
      font-size: 16px;
    }
  }

  .desktop & {
    .attendance-panel-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .attendance-panel-wrapper {
    width: 100%;
  }
  .current-date {
    font-size: 24px;
    font-weight: 700;
  }
  .red-icon {
    color: red;
  }
`;

export const ClockStyles = styled.div`
  display: flex;

  .wrapper-clock {
    display: flex;
    align-items: end;
    font-size: 56px;
    font-weight: 700;
    .colon-character {
      margin-left: 12px;
      margin-right: 12px;
    }
    .second-character {
      font-size: 30px;
      margin-bottom: 9px;
    }
  }
`;
